
import axios from "axios";
import { useState, useEffect } from "react";
import { useNavigate, useParams } from 'react-router-dom';
import classNames from "classnames";
import Coin_seller_orders from "./coin_seller_orders";
import Coin_seller_edit from "./coin_seller_edit";
import Cash_diary from './../../nhatkyorders.jsx';
import Cash_pay_home from "./coin_seller_pay_home";
import Cash_pay_orders from "./coin_seller_pay_orders";
import Cash_pay_card from "./coin_seller_pay_card";
import Post_content from '../../community/content/Blog_posts.jsx';

const Coin_home = () => {
    const { slug_2 } = useParams();
    const [userOption, setUserOption] = useState("changeCard");
    const navigate = useNavigate();
    return (
        <>
            {slug_2 === "orders" && (
                <Coin_seller_orders />
            )}
            {slug_2 === "edit_bank" && (
                <Coin_seller_edit />
            )}
            {slug_2 === "cash_diary" && (
                <Cash_diary category_main={'e_commerce'}/>
            )}
            {slug_2 === "pay_home" && (
                <Cash_pay_home />
            )}
            {(slug_2 === "pay_bank" || slug_2 === "pay_momo" || slug_2 === "pay_crypto" || slug_2 === "pay_binance") && (
                <Cash_pay_orders />
            )}
            {slug_2 === "buycard" && (
                <Cash_pay_card />
            )}
            {slug_2 === "guide" && (
                <>
                    <Post_content mode={'hust_media'} show_adsense={'YES'} show_adskeeper={'NO'} uri={'pay_out_guide'} />
                </>
            )}
        </>
    );
}

export default Coin_home;
